"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blurEventHandler = void 0;
exports.useDropdown = useDropdown;
var _react = _interopRequireDefault(require("react"));
/**
 * Executes the given callback if the Blur event was called
 * outside of the current element or any of its children
 *
 * @param callback The function to be invoked
 * @param stopPropagation Prevents the propagation of the blur event
 * @returns The focus event handler
 */
const blurEventHandler = (callback, stopPropagation = false) => {
  return event => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      if (stopPropagation) {
        event.stopPropagation();
      }
      callback();
    }
  };
};
exports.blurEventHandler = blurEventHandler;
/**
 * Provides the behavior and accessibility implementation for a Dropdown component
 */
function useDropdown({
  onBlur,
  onClose
} = {}) {
  const [isExpanded, setIsExpanded] = _react.default.useState(false);
  const [buttonHasFocus, setButtonHasFocus] = _react.default.useState(false);
  const openDropdown = _react.default.useCallback(() => {
    setIsExpanded(true);
    setButtonHasFocus(false);
  }, []);
  const closeDropdown = _react.default.useCallback(() => {
    setIsExpanded(false);
    setButtonHasFocus(true);
    onClose === null || onClose === void 0 || onClose();
  }, [onClose]);
  const toggleDropdown = _react.default.useCallback(() => isExpanded ? closeDropdown() : openDropdown(), [isExpanded, closeDropdown, openDropdown]);
  const handleBlur = _react.default.useMemo(() => blurEventHandler(() => {
    if (isExpanded) {
      closeDropdown();
    }
    setButtonHasFocus(false);
    onBlur === null || onBlur === void 0 || onBlur();
  }, isExpanded), [closeDropdown, isExpanded, onBlur]);
  const handleKeyDown = _react.default.useCallback(event => {
    if (event.key === 'Escape') {
      if (isExpanded) {
        closeDropdown();
        event.stopPropagation();
      }
    }
  }, [closeDropdown, isExpanded]);
  return _react.default.useMemo(() => ({
    handleBlur,
    handleKeyDown,
    isExpanded,
    isFocused: buttonHasFocus,
    openDropdown,
    closeDropdown,
    toggleDropdown
  }), [handleBlur, handleKeyDown, buttonHasFocus, isExpanded, openDropdown, closeDropdown, toggleDropdown]);
}
//# sourceMappingURL=dropdown.js.map